/* =========================================================
   SETTINGS
   ========================================================= */

const BEAUTY_FREE_SHIPPING = 650;


/* =========================================================
   SOUND
   ========================================================= */

function playBeautySound(
  celebration = false
) {

  try {

    const AudioContext =
      window.AudioContext ||
      window.webkitAudioContext;

    if (!AudioContext) return;

    const ctx =
      window.beautyAudioContext ||
      new AudioContext();

    window.beautyAudioContext =
      ctx;

    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const now =
      ctx.currentTime;


    /*
     * Main note
     */

    const osc =
      ctx.createOscillator();

    const gain =
      ctx.createGain();

    osc.type = 'sine';

    osc.frequency.setValueAtTime(
      740,
      now
    );

    osc.frequency.exponentialRampToValueAtTime(
      1046,
      now + .13
    );

    gain.gain.setValueAtTime(
      .0001,
      now
    );

    gain.gain.exponentialRampToValueAtTime(
      celebration ? .12 : .095,
      now + .015
    );

    gain.gain.exponentialRampToValueAtTime(
      .0001,
      now + .30
    );

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + .31);


    /*
     * Sparkle note
     */

    const sparkle =
      ctx.createOscillator();

    const sparkleGain =
      ctx.createGain();

    sparkle.type = 'sine';

    sparkle.frequency.setValueAtTime(
      celebration ? 1318 : 1174,
      now + .075
    );

    sparkleGain.gain.setValueAtTime(
      .0001,
      now
    );

    sparkleGain.gain.exponentialRampToValueAtTime(
      celebration ? .085 : .065,
      now + .09
    );

    sparkleGain.gain.exponentialRampToValueAtTime(
      .0001,
      now + .36
    );

    sparkle.connect(sparkleGain);
    sparkleGain.connect(ctx.destination);

    sparkle.start(now + .07);
    sparkle.stop(now + .38);

  } catch(e) {

    console.log(
      'Beauty sound unavailable'
    );

  }
}


/* =========================================================
   ADD TO CART
   ========================================================= */

function addDirectToCart(
  variantId,
  qtyInputId,
  btnId
) {

  const btn =
    document.getElementById(btnId);

  if (!btn) return;

  if (
    btn.dataset.loading === 'true'
  ) {
    return;
  }

  btn.dataset.loading = 'true';


  const originalHTML =
    btn.innerHTML;


  /* Quantity */

  let quantity = 1;

  if (qtyInputId) {

    const input =
      document.getElementById(
        qtyInputId
      );

    if (input) {

      const value =
        parseInt(
          input.value,
          10
        );

      if (
        !isNaN(value) &&
        value > 0
      ) {

        quantity = value;

      }
    }
  }


  /*
   * ======================================================
   * IMPORTANT:
   * EVERYTHING BELOW HAPPENS IMMEDIATELY.
   * NO WAITING FOR SHOPIFY.
   * ======================================================
   */


  btn.classList.add(
    'beauty-cart-pop'
  );


  playBeautySound(false);


  createBeautyParticles(btn);


  /*
   * Show "adding" state immediately
   */

  showBeautyToast(
    null,
    'loading'
  );


  /*
   * ======================================================
   * SHOPIFY REQUEST
   * ======================================================
   */

  fetch(

    window.Shopify.routes.root +
    'cart/add.js',

    {

      method: 'POST',

      headers: {

        'Content-Type':
          'application/json',

        'Accept':
          'application/json'

      },

      body: JSON.stringify({

        id: variantId,

        quantity: quantity

      })

    }

  )

  .then(async response => {

    if (!response.ok) {

      const error =
        await response
          .json()
          .catch(
            () => ({})
          );

      throw new Error(
        error.description ||
        'تعذر إضافة المنتج'
      );
    }

    return response.json();

  })


  /*
   * Get updated cart
   */

  .then(() => {

    return fetch(

      window.Shopify.routes.root +
      'cart.js',

      {
        headers: {
          'Accept':
            'application/json'
        }
      }

    );

  })


  .then(response => {

    if (!response.ok) {
      throw new Error(
        'Cart error'
      );
    }

    return response.json();

  })


  /*
   * SUCCESS
   */

  .then(cart => {

    updateBeautyCartCount(
      cart.item_count
    );

    animateBeautyCart();


    /*
     * Change existing toast
     * instead of creating another one.
     */

    showBeautyToast(
      cart,
      'success'
    );


    const total =
      cart.total_price / 100;


    if (
      total >=
      BEAUTY_FREE_SHIPPING
    ) {

      playBeautySound(true);

      createFreeShippingCelebration(
        btn
      );

      animateBeautyCart(
        true
      );

    }

  })


  /*
   * ERROR
   */

  .catch(error => {

    console.error(
      'Beauty Cart Error:',
      error
    );

    showBeautyToast(
      null,
      'error'
    );

  })


  /*
   * FINISH
   */

  .finally(() => {

    setTimeout(() => {

      btn.innerHTML =
        originalHTML;

      btn.style.pointerEvents =
        '';

      btn.dataset.loading =
        'false';

      btn.classList.remove(
        'beauty-cart-pop'
      );

    }, 350);

  });
}
/* =========================================================
   UNISON PRODUCT PAGE ADD TO CART
   ========================================================= */

function unisonProductAddFeedback(button) {
  if (!button) return;

  if (button.dataset.unisonClicked === 'true') return;
  button.dataset.unisonClicked = 'true';
  button.dataset.unisonFinalized = 'false';
  window.__unisonPendingAddButton = button;

  button.classList.remove('beauty-cart-pop');
  void button.offsetWidth;
  button.classList.add('beauty-cart-pop');

  if (typeof playBeautySound === 'function') playBeautySound(false);
  if (typeof createBeautyParticles === 'function') createBeautyParticles(button);
  if (typeof showBeautyToast === 'function') showBeautyToast(null, 'loading');
}

/* =========================================================
   PRODUCT PAGE — ADD SUCCESS
   ========================================================= */
function unisonProductAddSuccess(cart, button) {
  if (!button) return;
  if (button.dataset.unisonFinalized === 'true') return;
  button.dataset.unisonFinalized = 'true';

  const hasCartTotal = cart && typeof cart.total_price !== 'undefined';

  if (typeof updateBeautyCartCount === 'function' && cart && typeof cart.item_count !== 'undefined') {
    updateBeautyCartCount(cart.item_count);
  }

  if (typeof animateBeautyCart === 'function') animateBeautyCart();

  if (typeof showBeautyToast === 'function') {
    if (hasCartTotal) {
      showBeautyToast(cart, 'success');
    } else {
      showBeautyToast(null, 'success');
    }
  }

  if (hasCartTotal) {
    const total = cart.total_price / 100;
    const freeShipping = typeof BEAUTY_FREE_SHIPPING !== 'undefined' ? BEAUTY_FREE_SHIPPING : 1000;

    if (total >= freeShipping) {
      if (typeof playBeautySound === 'function') playBeautySound(true);
      if (typeof createFreeShippingCelebration === 'function') createFreeShippingCelebration(button);
      if (typeof animateBeautyCart === 'function') animateBeautyCart(true);
    }
  }

  button.dataset.unisonClicked = 'false';
}

/* =========================================================
   PRODUCT PAGE — ADD ERROR
   ========================================================= */
function unisonProductAddError(button) {
  if (button && button.dataset.unisonFinalized === 'true') return;
  if (button) button.dataset.unisonFinalized = 'true';
  if (typeof showBeautyToast === 'function') showBeautyToast(null, 'error');

  if (button) {
    button.dataset.unisonClicked = 'false';
    button.classList.remove('beauty-cart-pop');
  }
}


/* =========================================================
   PARTICLES
   ========================================================= */

function createBeautyParticles(
  button
) {

  const rect =
    button.getBoundingClientRect();


  const colors = [

    '#44BCA8',
    '#FF7F70',
    '#FFB38F',
    '#FFD166'

  ];


  /*
   * Increased from 42 to 58
   */

  const count = 58;


  for (
    let i = 0;
    i < count;
    i++
  ) {

    const particle =
      document.createElement(
        'span'
      );

    particle.className =
      'beauty-particle';


    particle.style.left =
      (
        rect.left +
        rect.width / 2
      ) + 'px';


    particle.style.top =
      (
        rect.top +
        rect.height / 2
      ) + 'px';


    particle.style.background =
      colors[
        Math.floor(
          Math.random() *
          colors.length
        )
      ];


    /*
     * Much wider explosion
     */

    const angle =
      Math.random() *
      Math.PI * 2;


    const distance =
      95 +
      Math.random() * 110;


    const x =
      Math.cos(angle) *
      distance;


    /*
     * Slight upward bias
     */

    const y =
      Math.sin(angle) *
      distance -
      30;


    particle.style.setProperty(
      '--x',
      x + 'px'
    );


    particle.style.setProperty(
      '--y',
      y + 'px'
    );


    particle.style.setProperty(
      '--rotate',
      (
        -260 +
        Math.random() * 520
      ) + 'deg'
    );


    /*
     * Shape variation
     */

    const shape =
      Math.random();


    if (shape < .25) {

      particle.style.width = '5px';
      particle.style.height = '12px';

    }

    else if (shape < .50) {

      particle.style.width = '10px';
      particle.style.height = '6px';
      particle.style.borderRadius = '50%';

    }

    else if (shape < .75) {

      particle.style.width = '9px';
      particle.style.height = '9px';

    }

    else {

      particle.style.width = '12px';
      particle.style.height = '5px';

    }


    particle.style.animationDelay =
      (
        Math.random() * .08
      ) + 's';


    document.body.appendChild(
      particle
    );


    setTimeout(() => {

      particle.remove();

    }, 1100);

  }
}


/* =========================================================
   FREE SHIPPING CELEBRATION
   ========================================================= */

function createFreeShippingCelebration(
  button
) {

  const rect =
    button.getBoundingClientRect();


  const colors = [

    '#44BCA8',
    '#FF7F70',
    '#FFB38F',
    '#FFD166'

  ];


  for (
    let i = 0;
    i < 70;
    i++
  ) {

    const particle =
      document.createElement(
        'span'
      );

    particle.className =
      'beauty-free-particle';


    particle.style.left =
      (
        rect.left +
        rect.width / 2
      ) + 'px';


    particle.style.top =
      (
        rect.top +
        rect.height / 2
      ) + 'px';


    particle.style.background =
      colors[
        Math.floor(
          Math.random() *
          colors.length
        )
      ];


    const angle =
      Math.random() *
      Math.PI * 2;


    const distance =
      110 +
      Math.random() * 140;


    particle.style.setProperty(
      '--x',
      (
        Math.cos(angle) *
        distance
      ) + 'px'
    );


    particle.style.setProperty(
      '--y',
      (
        Math.sin(angle) *
        distance -
        30
      ) + 'px'
    );


    particle.style.setProperty(
      '--rotate',
      (
        -270 +
        Math.random() * 540
      ) + 'deg'
    );


    document.body.appendChild(
      particle
    );


    setTimeout(() => {

      particle.remove();

    }, 1150);

  }
}


/* =========================================================
   CART ANIMATION
   ========================================================= */

function animateBeautyCart(
  celebration = false
) {

  const cart =
    document.querySelector(
      '.header__icon--cart'
    ) ||
    document.querySelector(
      'a[href$="/cart"]'
    ) ||
    document.querySelector(
      '[href*="/cart"]'
    );


  if (!cart) return;


  cart.classList.remove(
    'beauty-cart-pop',
    'beauty-free-glow'
  );


  void cart.offsetWidth;


  cart.classList.add(
    celebration
      ? 'beauty-free-glow'
      : 'beauty-cart-pop'
  );


  setTimeout(() => {

    cart.classList.remove(
      'beauty-cart-pop',
      'beauty-free-glow'
    );

  }, 850);
}


/* =========================================================
   CART COUNT
   ========================================================= */

function updateBeautyCartCount(
  count
) {

  const selectors = [

    '.cart-count-bubble',
    '[data-cart-count]',
    '.cart-count',
    '.cart-link__bubble'

  ];


  selectors.forEach(
    selector => {

      document
        .querySelectorAll(
          selector
        )
        .forEach(
          element => {

            element.textContent =
              count;

            element.style.display =
              count > 0
                ? ''
                : 'none';


            element.classList.remove(
              'beauty-count-pop'
            );


            void element.offsetWidth;


            element.classList.add(
              'beauty-count-pop'
            );

          }
        );

    }
  );
}


/* =========================================================
   TOAST
   ========================================================= */

function showBeautyToast(
  cart,
  state
) {

  let toast =
    document.getElementById(
      'beauty-cart-toast'
    );


  if (!toast) {

    document.body.insertAdjacentHTML(

      'beforeend',

      `

      <div
        id="beauty-cart-toast"
        role="status"
        aria-live="polite"
      >

        <button
          type="button"
          class="bct-close"
          aria-label="إغلاق الرسالة"
          onclick="hideBeautyToast()"
        >
          ×
        </button>


        <div class="bct-content">

          <div
            class="bct-check"
            id="bct-check"
          >
            ✓
          </div>


          <div class="bct-info">

            <div
              class="bct-title"
              id="bct-title"
            >
              بنضيفه للسلة ✨
            </div>


            <div
              class="bct-shipping"
              id="bct-shipping"
            >
              لحظة واحدة...
            </div>

          </div>


          <a
            class="bct-cart"
            href="${window.Shopify.routes.root}cart"
          >
            السلة
          </a>

        </div>

      </div>

      `

    );


    toast =
      document.getElementById(
        'beauty-cart-toast'
      );
  }


  const title =
    document.getElementById(
      'bct-title'
    );


  const shipping =
    document.getElementById(
      'bct-shipping'
    );


  const check =
    document.getElementById(
      'bct-check'
    );


  /*
   * LOADING
   */

  if (state === 'loading') {

    title.textContent =
      'بنضيفه للسلة ✨';

    shipping.textContent =
      'لحظة واحدة...';

    check.textContent =
      '🛍️';

    check.style.background =
      '#44BCA8';

  }


  /*
   * SUCCESS
   */

  if (state === 'success') {

    title.textContent =
      'اتضاف للسلة بنجاح ✨';

    check.textContent =
      '✓';

    check.style.background =
      '#44BCA8';


    if (!cart || typeof cart.total_price === 'undefined') {

      shipping.textContent =
        'تمت إضافة المنتج بنجاح ✨';

    }

    else {

      const total =
        cart.total_price / 100;

      if (
        total >=
        BEAUTY_FREE_SHIPPING
      ) {

        shipping.innerHTML =
          '🎉 <strong>مبروك! الشحن مجاني </strong>';

      }

      else {

        const remaining =
          Math.ceil(
            BEAUTY_FREE_SHIPPING -
            total
          );

        shipping.innerHTML =
          `باقي <strong>${remaining.toLocaleString('ar-EG')} ج.م</strong> للشحن المجاني ✨`;

      }

    }

  }


  /*
   * ERROR
   */

  if (state === 'error') {

    title.textContent =
      'حصلت مشكلة ❌';

    shipping.textContent =
      'جربي إضافة المنتج مرة تانية';

    check.textContent =
      '!';

    check.style.background =
      '#FF7F70';

  }


  /*
   * Position immediately
   */

  positionToastNearCart(
    toast
  );


  /*
   * Show immediately
   */

  toast.classList.add(
    'show'
  );


  /*
   * Don't hide the loading
   * state before Shopify responds.
   */

  if (
    state === 'loading'
  ) {

    clearTimeout(
      window.beautyToastTimer
    );

    return;

  }


  clearTimeout(
    window.beautyToastTimer
  );


  window.beautyToastTimer =
    setTimeout(
      hideBeautyToast,
      3000
    );
}


/* =========================================================
   POSITION NEAR CART
   ========================================================= */

function positionToastNearCart(
  toast
) {

  const cart =
    document.querySelector(
      '.header__icon--cart'
    ) ||
    document.querySelector(
      'a[href$="/cart"]'
    ) ||
    document.querySelector(
      '[href*="/cart"]'
    );


  /*
   * Fallback
   */

  if (!cart) {

    toast.style.left =
      'auto';

    toast.style.right =
      '18px';

    toast.style.top =
      '18px';

    toast.style.bottom =
      'auto';

    return;
  }


  const rect =
    cart.getBoundingClientRect();


  const width =
    Math.min(
      340,
      window.innerWidth - 18
    );


  let left =
    rect.right -
    width;


  left =
    Math.max(
      9,
      Math.min(
        left,
        window.innerWidth -
        width -
        9
      )
    );


  toast.style.left =
    left + 'px';

  toast.style.right =
    'auto';


  /*
   * Directly beneath the cart
   */

  toast.style.top =
    (
      rect.bottom +
      10
    ) + 'px';

  toast.style.bottom =
    'auto';
}


/* =========================================================
   HIDE
   ========================================================= */

function hideBeautyToast() {

  const toast =
    document.getElementById(
      'beauty-cart-toast'
    );

  if (!toast) return;

  toast.classList.remove(
    'show'
  );
}


/* =========================================================
   KEEP POSITION CORRECT ON RESIZE
   ========================================================= */

window.addEventListener(
  'resize',
  () => {

    const toast =
      document.getElementById(
        'beauty-cart-toast'
      );

    if (
      toast &&
      toast.classList.contains('show')
    ) {

      positionToastNearCart(
        toast
      );

    }

  }
);

/* =========================================================
   PUBLIC API + PRODUCT FORM FALLBACK BINDING
   Keep the feedback API explicit so it is available to theme
   scripts regardless of browser/global-scope behavior.
   ========================================================= */
window.unisonProductAddFeedback = unisonProductAddFeedback;
window.unisonProductAddSuccess = unisonProductAddSuccess;
window.unisonProductAddError = unisonProductAddError;

/*
 * Universal success bridge.
 * The visible Add to Cart control on this theme can be handled by a script
 * other than product-form.js. The click fallback therefore starts the effect,
 * while this bridge watches the real Shopify cart/add request and finalizes
 * the same toast only after Shopify confirms success.
 */
if (!window.__unisonCartFetchBridgeInstalled && typeof window.fetch === 'function') {
  window.__unisonCartFetchBridgeInstalled = true;
  const __unisonNativeFetch = window.fetch.bind(window);

  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url) ||
      (window.routes && window.routes.cart_add_url && String(url).includes(window.routes.cart_add_url));

    const request = __unisonNativeFetch(input, init);

    if (isCartAdd) {
      request.then((response) => {
        const button = window.__unisonPendingAddButton;
        if (!button || button.dataset.unisonFinalized === 'true') return;

        if (!response.ok) {
          window.unisonProductAddError(button);
          return;
        }

        return __unisonNativeFetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
          .then((cartResponse) => {
            if (!cartResponse.ok) throw new Error('Unable to read updated cart');
            return cartResponse.json();
          })
          .then((cart) => window.unisonProductAddSuccess(cart, button))
          .catch(() => window.unisonProductAddSuccess(null, button));
      }).catch(() => {
        const button = window.__unisonPendingAddButton;
        if (button && button.dataset.unisonFinalized !== 'true') {
          window.unisonProductAddError(button);
        }
      });
    }

    return request;
  };
}

/*
 * Robust fallback binding for every product-page add button.
 * Some themes place the visible/sticky Add to Cart button outside
 * the <product-form> element, so do not rely on one selector only.
 */
function unisonFindAddButton(target) {
  if (!target || !target.closest) return null;

  const candidate = target.closest('button, input[type="submit"], [role="button"]');
  if (!candidate) return null;

  const label = [
    candidate.getAttribute('name') || '',
    candidate.getAttribute('data-action') || '',
    candidate.getAttribute('data-type') || '',
    candidate.getAttribute('aria-label') || '',
    candidate.value || '',
    candidate.textContent || ''
  ].join(' ').replace(/\s+/g, ' ').trim().toLowerCase();

  if (/buy\s*now|checkout|dynamic-checkout|اشتري الآن|اشتر الآن|الدفع/.test(label)) return null;

  const directAdd = candidate.matches('[name="add"], [data-add-to-cart], [data-action="add-to-cart"]');
  const textAdd = /add\s*to\s*cart|add\s*to\s*bag|أضف\s*(إلى|لـ)?\s*السلة|اضف\s*(الى|ل)?\s*السلة/.test(label);
  const form = candidate.closest('form');
  const productForm = candidate.closest('product-form');
  const hasVariant = !!(form && form.querySelector('[name="id"]')) || !!productForm;

  return (directAdd || textAdd || (candidate.type === 'submit' && hasVariant)) ? candidate : null;
}

function unisonTriggerFeedback(button) {
  if (!button) return;
  if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
  window.unisonProductAddFeedback(button);
}

document.addEventListener('click', (event) => {
  unisonTriggerFeedback(unisonFindAddButton(event.target));
}, true);

/* Covers keyboard/Enter submission even when no click event occurs. */
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form || !form.querySelector) return;
  const hasVariant = form.querySelector('[name="id"]');
  if (!hasVariant) return;

  const button = form.querySelector('[name="add"], button[type="submit"]');
  unisonTriggerFeedback(button);
}, true);

